export const clientsKeys = {
  all: ['clients'] as const,
  list: () => [...clientsKeys.all, 'list'] as const,
  byId: (id: string) => [...clientsKeys.all, 'by-id', id] as const,
};

export const userMetadataKeys = {
  all: ['user-metadata'] as const,
};

export const passTypesKeys = {
  all: ['pass-types'] as const,
  list: () => [...passTypesKeys.all, 'list'] as const,
  byId: (id: string) => [...passTypesKeys.all, 'by-id', id] as const,
};

export const actionLogsKeys = {
  all: ['action-logs'] as const,
  byClient: (id: string) => [...actionLogsKeys.all, 'by-client', id] as const,
};

export const subscriptionKeys = {
  all: ['subscription'] as const,
  active: () => [...subscriptionKeys.all, 'active'] as const,
  invoice: (checkoutId: string) => [...subscriptionKeys.all, 'invoice', checkoutId] as const,
  checkoutStatus: (checkoutId: string) =>
    [...subscriptionKeys.all, 'checkout-status', checkoutId] as const,
};
